import designSystemStyles from "@shared/styles/designSystemStyles"
import { CloseButton } from "./Button"
import { HorizontalContainer, VerticalContainer } from "./Containers"
import { SmallText, Text } from "./Texts"

export interface ModalHeaderProps {
    title: string
    /**
     * One line of context under the title, inside the header block rather than the
     * content area — it describes the modal, so it belongs above the divider with the
     * title and scrolls away with neither.
     */
    subtitle?: string
    onClose?: () => void
    className?: string
}

export const ModalHeader: React.FC<ModalHeaderProps> = (props) => {
    return (
        <HorizontalContainer
            gap={designSystemStyles.gapNone}
            width="100%"
            justifyContent="space-between"
            // With a subtitle the left column is two lines tall; keeping the close
            // button centred against both would drop it below the title it belongs to.
            alignment={props.subtitle ? "flex-start" : "center"}
            className={['DSModalHeader', props.className].filter(Boolean).join(' ')}
        >
            <VerticalContainer gap={designSystemStyles.gapXxxSm} alignment="left" width="100%">
                <Text text={"**"+props.title+"**"} markdown={true}/>
                {props.subtitle ? (
                    <SmallText
                        text={props.subtitle}
                        color={designSystemStyles.colorTextSecondary}
                    />
                ) : null}
            </VerticalContainer>
            {props.onClose ? <CloseButton onClick={props.onClose}/> : null}
        </HorizontalContainer>
    )
}
